import allowedRoutes from 'components';

const removeParamsFromPath = (path) => {
    // Check if the path contains a colon (':')
    const hasParams = path.includes("/:");

    if (hasParams) {
        // If the path contains parameters, remove them by splitting the path and taking the first part before the colon
        const cleanPath = path.split("/:")[0];
        return cleanPath;
    }

    // If the path does not contain parameters, return the original path as it is
    return path;
};

const sideBarBuilder = (userPermissions) => {
    const defaultSideBarData = [
        {
            "name": "Dashboard",
            "path": "/",
            "icon": "bi-grid",
        },
        {
            "name": "Company Docs",
            "path": "/edocs",
            "icon": "bi-files",
        }
    ];

    const userSidebarData = Object.entries(allowedRoutes)
        .filter(([key, permissions]) => {
            // Map old "sheet_management" key to new "setting_management" for backward compatibility
            // If checking "setting_management", also check for "sheet_management" from server
            let permissionKey = key;
            if (key === 'setting_management' && !userPermissions.hasOwnProperty(key) && userPermissions.hasOwnProperty('sheet_management')) {
                permissionKey = 'sheet_management';
            }
            return userPermissions.hasOwnProperty(permissionKey) && userPermissions[permissionKey].isComponent && permissions.active_sidebar;
        })
        .map(([key, permissions]) => ({
            name: permissions.component_label,
            path: removeParamsFromPath(permissions.route),
            icon: permissions.icon,
        }));

    return [...defaultSideBarData, ...userSidebarData];
};

export default sideBarBuilder;